import _ from 'lodash';
import { HT_REFERENTIALS } from '../../config';
import { Calculator } from '../../Store/helpers/Calculator';

function convertZoneName(zone) {
  const words = zone.split('_');
  if (words.slice(-1)[0] === 'damages') {
    words.pop();
  }
  return words.join('_');
}

// calculate the totals form the damages
export default function calculateTotals(damages, inspection) {
  const calculator = new Calculator({ country: inspection?.country?.toUpperCase() });
  const totals = {};
  damages.forEach((damage) => {
    let { zone } = damage;
    const { cost, referential, is_custom } = damage;
    zone = convertZoneName(zone);

    // calcul the total for the referential
    const prevTotal = _.get(totals, `${referential}`, 0);
    // totals[`${referential}`] = prevTotal + cost;
    if ((HT_REFERENTIALS.includes(referential) || referential.includes('internal')) && is_custom === true) {
      totals[`${referential}`] = prevTotal + Math.round(cost * calculator.getTaxExcludedVat());
    } else {
      totals[`${referential}`] = prevTotal + cost;
    }
    // calculate the total for the referential and zone
    const pathTotalZone = `${zone}.${referential}`;
    const prevTotalZone = _.get(totals, pathTotalZone, 0);
    const SectionTotal =
      (HT_REFERENTIALS.includes(referential) || referential.includes('internal')) && is_custom === true
        ? prevTotalZone + Math.round(cost * calculator.getTaxExcludedVat())
        : prevTotalZone + cost;
    _.set(totals, pathTotalZone, SectionTotal);
  });
  return totals;
}
